module.exports = __webpack_public_path__ + "media/images/icons/outlined/video-camera-add-9fe737c0a8c73f933e975cd0fa2c65c3.svg";